import { actions as newRequestAction } from '../../containers/CreateRequest/new-request.actions';
import executeTimeActions from '../../actions/execute-time.actions';

export const workerKeys = {
  master: 'master',
  executor: 'executer',
  applicant: 'applicant',
  creator: 'creator',
};

export const workerEntities = {
  [workerKeys.master]: {
    title: 'Мастер',
    text: 'мастера',
    fn: ({ dispatch, param, worker }) => {
      dispatch(newRequestAction.fetchWorkerList(param));
      dispatch(
        executeTimeActions.openMasterModal(
          param.requestId + '',
          worker && worker.id + ''
        )
      );
    },
  },
  [workerKeys.executor]: {
    title: 'Исполнитель',
    text: 'исполнителя',
    fn: ({ dispatch, param, worker }) => {
      dispatch(newRequestAction.fetchExecuterList(param));
      dispatch(
        executeTimeActions.openExecuterModal(
          param.requestId + '',
          worker && worker.id + ''
        )
      );
    },
  },
  [workerKeys.applicant]: {
    title: 'Заявитель',
    text: 'заявителя',
  },
  [workerKeys.creator]: {
    title: 'Создатель',
    text: 'создателя',
  },
};
